// Centralized prefetchers for lazy route chunks.
// Calling one of these triggers the dynamic import early so the chunk
// is in memory by the time the user clicks the link.

export const routePrefetchers = {
  home: () => import("@/pages/Home"),
  services: () => import("@/pages/Services"),
  serviceDetail: () => import("@/pages/ServiceDetail"),
  industries: () => import("@/pages/Industries"),
  industryDetail: () => import("@/pages/IndustryDetail"),
  approach: () => import("@/pages/Approach"),
  about: () => import("@/pages/About"),
  contact: () => import("@/pages/Contact"),
  insights: () => import("@/pages/Insights"),
  insightDetail: () => import("@/pages/InsightDetail"),
  privacy: () => import("@/pages/legal/Privacy"),
  cookies: () => import("@/pages/legal/Cookies"),
  terms: () => import("@/pages/legal/Terms"),
} as const;

export type PrefetchKey = keyof typeof routePrefetchers;
